import { Card, Col, Row } from 'react-bootstrap';
import Flex from '@/components/common/Flex';

const TITLE_WIDTHS = ['72%', '64%', '78%', '58%', '70%', '66%'];
const DESC_WIDTHS = [
  ['96%', '82%', '68%'],
  ['92%', '76%', '55%'],
  ['98%', '84%', '62%'],
  ['90%', '70%', '72%'],
  ['94%', '80%', '58%'],
  ['88%', '74%', '66%']
];

type McpSkillsListPreloadProps = {
  cards?: number;
};

/** Skeleton grid matching skill cards on `/chat/skills`. */
export function McpSkillsListPreload({ cards = 6 }: McpSkillsListPreloadProps) {
  return (
    <Row className="g-3 placeholder-glow" aria-hidden>
      {Array.from({ length: cards }, (_, index) => {
        const desc = DESC_WIDTHS[index % DESC_WIDTHS.length];
        return (
          <Col key={index} xs={12} md={6} xl={4}>
            <Card className="mcp-skill-card h-100">
              <Card.Body>
                <Flex
                  alignItems="start"
                  justifyContent="between"
                  className="gap-2 mb-2"
                >
                  <span
                    className="placeholder rounded-pill"
                    style={{ width: 72, height: 22 }}
                  />
                  <span
                    className="placeholder rounded flex-shrink-0"
                    style={{ width: 64, height: 12 }}
                  />
                </Flex>

                <span
                  className="placeholder rounded d-block mb-2"
                  style={{
                    width: TITLE_WIDTHS[index % TITLE_WIDTHS.length],
                    height: 16
                  }}
                />

                <div>
                  {desc.map((width, line) => (
                    <span
                      key={line}
                      className="placeholder rounded d-block mb-2"
                      style={{ width, height: 11 }}
                    />
                  ))}
                </div>
              </Card.Body>

              <Card.Footer>
                <Flex alignItems="center" className="gap-2 flex-wrap">
                  <span
                    className="placeholder rounded-pill"
                    style={{ width: 108, height: 28 }}
                  />
                  <span
                    className="placeholder rounded-pill"
                    style={{ width: 132, height: 28 }}
                  />
                </Flex>
              </Card.Footer>
            </Card>
          </Col>
        );
      })}
    </Row>
  );
}
